/**
 * @generated SignedSource<<7e378c6306c796db51ce378c56d9eaf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespSearchResultContainer_itemSearch$data = {
  readonly displayUriRef: string | null;
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly item: {
        readonly seller: {
          readonly " $fragmentSpreads": FragmentRefs<"SbSharedAuctionItemsBanner_seller">;
        } | null;
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"SbSharedItemTrackingProvider_item" | "SharedItemTile_item">;
      } | null;
    } | null;
  } | null> | null;
  readonly seller: {
    readonly " $fragmentSpreads": FragmentRefs<"SbSharedAuctionItemsBanner_seller">;
  } | null;
  readonly sponsored?: {
    readonly items: ReadonlyArray<{
      readonly serviceId: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"SbSharedItemTrackingProvider_item" | "SharedItemTile_item">;
    } | null> | null;
    readonly metadata: ReadonlyArray<{
      readonly clickTrackerLink: string | null;
      readonly impressionTrackerLink: string | null;
      readonly itemId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedItemTrackingProvider_itemSearch" | "SbSharedProductAdWrapper_itemSearch" | "SharedItemTile_itemSearch" | "useMeasurementUnit_itemSearch" | "useSearchCorrections_itemSearch">;
  readonly " $fragmentType": "SbRespSearchResultContainer_itemSearch";
};
export type SbRespSearchResultContainer_itemSearch$key = {
  readonly " $data"?: SbRespSearchResultContainer_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespSearchResultContainer_itemSearch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "SearchBrowseParsedParam",
  "kind": "LinkedField",
  "name": "appliedFilters",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParamValue",
      "kind": "LinkedField",
      "name": "values",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedAuctionItemsBanner_seller"
    }
  ],
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "SbSharedItemTrackingProvider_item"
},
v4 = {
  "args": [
    {
      "kind": "Variable",
      "name": "fetchVideo",
      "variableName": "fetchTileVideo"
    },
    {
      "kind": "Variable",
      "name": "isTrade",
      "variableName": "isTrade"
    },
    {
      "kind": "Variable",
      "name": "priceBookName",
      "variableName": "priceBookName"
    },
    {
      "kind": "Variable",
      "name": "showSeller",
      "variableName": "showSeller"
    },
    {
      "kind": "Variable",
      "name": "userCountryCode",
      "variableName": "userCountryCode"
    }
  ],
  "kind": "FragmentSpread",
  "name": "SharedItemTile_item"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchTileVideo"
    },
    {
      "kind": "RootArgument",
      "name": "includeSponsoredItems"
    },
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "priceBookName"
    },
    {
      "kind": "RootArgument",
      "name": "showSeller"
    },
    {
      "kind": "RootArgument",
      "name": "userCountryCode"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespSearchResultContainer_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayUriRef",
      "storageKey": null
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useMeasurementUnit_itemSearch",
      "selections": [
        (v0/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedItemTrackingProvider_itemSearch"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "useSearchCorrections_itemSearch",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchCorrectionsType",
          "kind": "LinkedField",
          "name": "searchCorrections",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "semanticSearchTerm",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "classificationLevel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "classificationSearchTerm",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v0/*: any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedProductAdWrapper_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_itemSearch"
    },
    (v1/*: any*/),
    {
      "condition": "includeSponsoredItems",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchSponsored",
          "kind": "LinkedField",
          "name": "sponsored",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "items",
              "plural": true,
              "selections": [
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemSearchSponsoredMetadata",
              "kind": "LinkedField",
              "name": "metadata",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "impressionTrackerLink",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "clickTrackerLink",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemSearchQueryEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchResult",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "item",
              "plural": false,
              "selections": [
                (v2/*: any*/),
                (v1/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "4f699bca1ac705dd9405e23e86e847c8";

export default node;
